/** global cache key **/

export const CK_APP_CONFIG = 'appConfig';
export const CK_CHANNEL_CONFIG = 'channelConfig';
export const CK_PROFILE = 'profile';
export const CK_WATCH_180_KEY = 'has_reached_180s';
